import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Search from '@/views/Search.vue'
import NormaDetalhe from '@/views/NormaDetalhe.vue'
import Destaques from '@/views/DestaquesView.vue'
import Recentes from '@/views/RecentesView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'search',
    component: Search,
    meta: { title: 'Home - Atos Normativos' },
  },
  {
    path: '/normaDetalhe',
    name: 'norma-detalhe',
    component: NormaDetalhe,
    meta: { title: 'Detalhe - Atos Normativos' },
  },
  {
    path: '/destaques',
    name: 'destaques',
    component: Destaques,
    meta: { title: 'Destaques - Publicações destacadas' },
  },
  {
    path: '/recentes',
    name: 'recentes',
    component: Recentes,
    meta: { title: 'Publicações recentes' },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
